<template>
  <div class="dataTables_wrapper form-inline dt-bootstrap">
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">平台</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">廣告</th>
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="show.brand">更新時間</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="show.brand">建立時間</th>-->
            <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-fat" v-if="show.menuDetail"></th>-->
          </tr>
          </thead>
          <tbody>
            <tr>
              <!-- cloumn 0 -->
              <td class="sorting_1">1</td>
              <!-- column 1-->
              <td><img class="img-brand-table" src="/static/img/nidin_logo.png"></td>
              <!-- column 2-->
              <td>
                Nidin
              </td>

              <td>
                <router-link to="/platformAdTable">
                  <button class="btn btn-default"><i class="fa fa-file-image-o" aria-hidden="true"></i></button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// PlatformTableTemp.vue?5ac90b7f